import _styled from "styled-components";
const _excluded = ["style", "className", "children", "size"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import { stylePropType } from '@adsk/alloy-react-theme';
import { VIEWBOXES } from '../consts';
import useIconVariation from '../useIconVariation';
/**
 * A component for rendering single color icons as inline SVGs.
 */
const Icon = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      style,
      className,
      children,
      size = 24
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(_StyledSvg, _extends({
    ref: ref,
    height: size,
    width: size,
    viewBox: VIEWBOXES._24,
    fill: "currentColor",
    "aria-hidden": "true",
    className: className
  }, props, {
    $_css: [{
      flex: 'none'
    }, style].filter(Boolean)
  }), children);
});
Icon.displayName = 'Icon';
Icon.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Icon content, if rendering a custom SVG */
  children: PropTypes.any,
  /** Square size of icon (in pixels, defaults to 24) */
  size: PropTypes.number
};
export const generateRenderedIcon = (icons, dataTestId) => {
  const RenderedIcon = (props, ref) => {
    const {
      d,
      viewBox
    } = useIconVariation({
      size: props.size,
      icons
    });
    return /*#__PURE__*/React.createElement(Icon, _extends({
      "data-testid": dataTestId,
      ref: ref,
      viewBox: viewBox
    }, props), /*#__PURE__*/React.createElement("path", {
      d: d
    }));
  };
  return RenderedIcon;
};
export default Icon;
var _StyledSvg = _styled("svg").withConfig({
  displayName: "Icon___StyledSvg",
  componentId: "sc-e9hqt8-0"
})(["", ""], p => p.$_css);
//# sourceMappingURL=Icon.js.map